/**
 * Footer account card modes matching Figma primary sidebar views.
 */
export const AccountMode = {
	Portal: "portal",
	Application: "application",
	Standard: "standard",
} as const;

export type AccountMode = (typeof AccountMode)[keyof typeof AccountMode];
